import { twMerge } from 'tailwind-merge';

import { SkeletonChips, SkeletonFilter } from '../common';
import { PlayersList } from './PlayersList';

type PlayersSkeletonProps = {
  className?: string;
};

export default function PlayersSkeleton(props: PlayersSkeletonProps) {
  const { className } = props;

  return (
    <div className={twMerge('flex flex-col gap-[8px] animate-pulse', className)}>
      <SkeletonFilter count={3} />
      <SkeletonChips />
      <PlayersList />
    </div>
  );
}
